import useFetch from '@hooks/useFetch';
import { useSelector } from 'react-redux';

import { getIsLoggedIn } from '@selectors/auth';

/**
 * @returns { Object } An object with the response and function to refetch access control data
 */
const useLiveMentorship = (goalUID) => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  const { data, mutate } = useFetch(
    isLoggedIn
      ? `v1/live_interaction/learner/sessions/?goal_uid=${goalUID}&state=1`
      : null
  );

  return {
    data: data?.results || [],
    mutate
  };
};

export default useLiveMentorship;
